document.addEventListener("DOMContentLoaded", function () {
  const textSliders = document.querySelectorAll(".text-slider__swiper");

  if (textSliders.length > 0 && typeof Swiper !== "undefined") {
    textSliders.forEach(function (sliderElement) {
      new Swiper(sliderElement, {
        slidesPerView: 'auto',
        speed: 300,
        threshold: 5,
        touchStartPreventDefault: false,
        passiveListeners: true,
        touchReleaseOnEdges: true,
        preventInteractionOnTransition: false,
        autoplay: {
            delay: sliderElement.getAttribute('data-autoplay') ,
          },
        breakpoints: {
          480: {
            slidesPerView: 2,
          },
          750: {
            slidesPerView: 2,
          },
          990: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 4,
          },
        },

        navigation: {
          nextEl: ".text-slider__button-next",
          prevEl: ".text-slider__button-prev",
        },

        pagination: {
          el: ".text-slider__pagination",
          clickable: true,
          dynamicBullets: true,
        },

        loop: false,
        grabCursor: true,
        autoHeight: false,
        centeredSlides: true,
        centeredSlidesBounds: true,

        a11y: {
          enabled: true,
          prevSlideMessage: "Önceki slayt",
          nextSlideMessage: "Sonraki slayt",
        },

        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },

        mousewheel: {
          enabled: false,
        },

        observer: true,
        observeParents: true,
      });
    });
  }
});
